import script from "./CreateLottery.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateLottery.vue?vue&type=script&setup=true&lang=js"

import "./CreateLottery.vue?vue&type=style&index=0&id=cfdef1c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfdef1c0"]])

export default __exports__